import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback } from "react";
import { useModal, useTermsAgreeMutation } from "@/hooks";
import TermAgreementForm from "@/components/Form/TermAgreementForm";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TermsAgreementModal(_ref) {
  var terms = _ref.terms;

  var _useModal = useModal(),
      hideModal = _useModal.hideModal;

  var _useTermsAgreeMutatio = useTermsAgreeMutation({
    onCompleted: function onCompleted() {
      hideModal();
    }
  }),
      _useTermsAgreeMutatio2 = _slicedToArray(_useTermsAgreeMutatio, 1),
      agree = _useTermsAgreeMutatio2[0];

  var onSubmit = useCallback(function (data) {
    if (data.terms) {}

    var keys = terms.filter(function (term) {
      if (data.terms && term.required) {
        return true;
      } else if (data.termsAd && term.id_key === "ad") {
        return true;
      } else if (data.termsMail && term.id_key === "spoox_mail") {
        return true;
      } else if (data.termsMail && term.id_key === "spoox_mail_adult") {
        return true;
      } else {
        return false;
      }
    }).map(function (term) {
      return term.current_revision.unique_key;
    });
    agree({
      variables: {
        keys: keys
      }
    });
  }, [terms]);
  return /*#__PURE__*/_jsx(TermAgreementForm, {
    onSubmit: onSubmit,
    terms: terms
  });
}